import NewClientScreen from "@/components/screens/client/new";

export default function NewClient() {
  return <NewClientScreen />;
}
